<template>
  <div class="relative w-full h-full container-works">

    <div class="w-full h-full space-y-10 py-[3vw] relative z-3 ">
      <!-- <h2 class="inline-flex text-base md:text-[2.111vw] big-screen:text-[3vw] leading-[1] animate-content-motion opacity-0">
        <div class="highlighter higlighter-0 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "Motion Graphics" }}</span>
      </h2> -->
      <div class="grid grid-cols-3 gap-5 animate-content-motion opacity-0">
        <div class="cursor-pointer space-y-5 h-fit works-0 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(Works3DAnimation[0].href)">
          <figure class="shadow-lg rounded-xl  overflow-hidden">
            <img class="aspect-[4/5] object-cover image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="Works3DAnimation[0].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ Works3DAnimation[0].title }}</h2>
        </div>
        <div class="cursor-pointer space-y-5 h-fit works-1 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(Works3DAnimation[1].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class="aspect-[5/4] object-cover image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="Works3DAnimation[1].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ Works3DAnimation[1].title }}</h2>
        </div>
        <div class="cursor-pointer space-y-5 h-fit works-2 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(Works3DAnimation[2].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class="rounded-xl image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="Works3DAnimation[2].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ Works3DAnimation[2].title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full h-full space-y-10 py-[3vw] relative z-3">
      <!-- <h2 class="inline-flex text-base md:text-[2.111vw] big-screen:text-[3vw] leading-[1] animate-content-animation">
        <div class="highlighter higlighter-1 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "3D Animation" }}</span>
      </h2> -->
      <div class="flex gap-5 animate-content-animation opacity-0">
        <div class="cursor-pointer space-y-5 h-fit w-1/3  works-3 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(WorksMotion[1].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class=" aspect-video object-cover image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="WorksMotion[1].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ WorksMotion[1].title }}</h2>
        </div>
        <div class="cursor-pointer space-y-5 h-fit w-2/3  works-4 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(WorksMotion[0].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class="aspect-[5/3] object-cover image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="WorksMotion[0].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ WorksMotion[0].title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full h-full space-y-10 py-[3vw] relative z-3">
      <!-- <h2 class="inline-flex text-base md:text-[2.111vw] big-screen:text-[3vw] leading-[1] animate-content-anamorphic">
        <div class="highlighter higlighter-2 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "3D Anamorphic" }}</span>
      </h2> -->
      <div class="flex gap-5 animate-content-anamorphic opacity-0">
        <div class="cursor-pointer space-y-5 h-fit w-1/3  works-5 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(Works3DAnamorphic[0].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class="aspect-[3/3.5] object-cover object-[top_0_right_-6vw] image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="Works3DAnamorphic[0].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ Works3DAnamorphic[0].title }}</h2>
        </div>
        <div class="cursor-pointer space-y-5 h-fit w-2/3  works-6 group" @mouseenter="toggleHover(true, 'arrow')" @mouseleave="toggleHover(false)" @click="openLink(Works3DAnamorphic[1].href)">
          <figure class="shadow-lg rounded-xl overflow-hidden">
            <img class="aspect-[16/7] object-cover image scale-[1.1] group-hover:!scale-[1] transition-transform duration-700 opacity-0" :src="Works3DAnamorphic[1].thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-3xl md:text-[1.3vw] font-semibold big-screen:text-[1.25vw] leading-[1.3] ">{{ Works3DAnamorphic[1].title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full justify-center flex mb-12">
      <div class="inline-flex see-more">
        <NuxtLink to="/works" class="animate-content-paragraph block text-white uppercase border-[0.05vw] border-ellie-blue bg-ellie-blue rounded-full text-sm px-8 py-2 md:px-[1.5vw] md:py-[0.8vw] text-[1.3w] big-screen:text-[1.3vw] tracking-[0.01vw] big-screen:text-[1.25vw] leading-[1.3] tracking-[0.01vw] hover:bg-opacity-80 hover:text-white transition-colors duration-300" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
          View All Projects
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $gsap, $ScrollTrigger } = useNuxtApp();
const mainStore = useMainStore();

const init = () => {
  $gsap
    .timeline({
      scrollTrigger: {
        trigger: '.container-works',
        start: '0 0',
        end: '100% 100%',
        scrub: 1,
      },
    })
    .fromTo('.works-0', { y: 0 }, { y: 0 }, 0)
    .fromTo('.works-1', { y: 50 }, { y: 0 }, 0)
    .fromTo('.works-2', { y: 200 }, { y: 0 }, 0)

    .fromTo('.works-3', { y: 200 }, { y: 0 }, 0)
    .fromTo('.works-4', { y: 250 }, { y: 0 }, 0)

    .fromTo('.works-5', { y: 200 }, { y: 0 }, 0)
    .fromTo('.works-6', { y: 650 }, { y: 0 }, 0)
    .fromTo('.see-more', { y: 150, opacity: 0 }, { y: 0, opacity: 1 }, 0);

  const target0 = document.querySelector('.animate-content-motion');
  const target1 = document.querySelector('.animate-content-animation');
  const target2 = document.querySelector('.animate-content-anamorphic');

  const obsTarget0 = useIntersectionObserver(
    target0,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animate-content-motion');
        observerElement.unobserve(target0);
      }
    },
  );

  const obsTarget1 = useIntersectionObserver(
    target1,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animate-content-animation');
        observerElement.unobserve(target1);
      }
    },
  );

  const obsTarget2 = useIntersectionObserver(
    target2,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animate-content-anamorphic');
        observerElement.unobserve(target2);
      }
    },
  );
};

const animateContent = (target) => {
  $gsap.to(`.${target}`, {
    opacity: 1,
    stagger: 0.3,
    ease: 'power1.out',
    // onComplete: () => {
    //   animateHighligter(target);
    // },
  });

  $gsap.to(`.${target} .image`, {
    opacity: 1,
    stagger: 0.3,
    y: 0,
    ease: 'power1.out',
    duration: 1,
  });
};

const animateHighligter = (target) => {
  $gsap.fromTo(
    `h2.${target} .highlighter`,
    { width: 0 }, // Initial state
    {
      width: '100%',
      duration: 0.7, // Animation duration
      stagger: 0.2, // Delay between each element's animation
      ease: 'power2.out', // Ease for smooth animation
    },
  );
};

const Works3DAnimation = ref([
  {
    id: 0,
    title: 'Assemble Your Magic Heroes',
    thumb: '/works/magiclean.webp',
    desc: '',
    href: '/works/kao-magiclean-assemble-your-magic-heroes',
  },
  {
    id: 1,
    title: 'Simmons World Class Sleep',
    thumb: '/works/simmons-bedding.webp',
    desc: '',
    href: '/works/simmons-world-class-sleep',
  },
  {
    id: 2,
    title: 'Gryphon Tea New Packaging',
    thumb: '/works/gryphon.webp',
    desc: '',
    href: '/works/gryphon.webp',
  },
]);
const WorksMotion = ref([
  {
    id: 0,
    title: 'National University Of Singapore Brand',
    thumb: '/works/nus.webp',
    desc: '',
    href: '/works/nus-brandvideo',
  },
  {
    id: 1,
    title: "Lazada's Birthday",
    thumb: '/works/lazada.webp',
    desc: '',
    href: '/works/lazada',
  },
  {
    id: 2,
    title: '',
    thumb: '',
    desc: '',
    href: '',
  },
]);
const Works3DAnamorphic = ref([
  {
    id: 0,
    title: "Martell N'oblige 3D Anamorphic",
    thumb: '/works/martell.webp',
    desc: '',
    href: '/works/martell-noblidge',
  },
  {
    id: 1,
    title: 'Singapore’s Exchange IPO Launch',
    thumb: '/works/sgx.webp',
    desc: '',
    // href: '/works/sgx-ipo-launch',
    href: '/works/martell-noblidge',
  },
  {
    id: 2,
    title: '',
    thumb: '',
    desc: '',
    href: '',
  },
]);

const openLink = (link) => {
  window.open(link, '_self');
};

const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};

onMounted(() => {
  nextTick(() => {
    const to = setTimeout(() => {
      init();
      clearTimeout(to);
    }, 1000);
  });
});
</script>

<style lang="scss" scoped>

</style>
